module.exports = __WEBPACK_EXTERNAL_MODULE_14__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","animations"],"commonjs":"@angular/animations","commonjs2":"@angular/animations","amd":"@angular/animations"}
// module id = 14
// module chunks = 0 1